/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import BookingPackagesBasicCredits from "pages/Front/Booking/BookingPackagesBasicCredits";
import {PackageCategory} from "types/enums/PackageCategory";
import {useTypedSelector} from "helpers/reducers";
import BookingPackagesFamilyView from "pages/Front/Booking/BookingPackagesFamilyView";
import BookingPackagesEventsView from "pages/Front/Booking/BookingPackagesEventsView";

export interface Params {}

interface BookingPackagesNewProps extends RouteComponentProps<Params> {}

const BookingPackagesNew = (props: BookingPackagesNewProps) => {
    const filter = useTypedSelector(state => state.bookingState.bookingProcess.filter);
    const categoriesWithFamily = [
        PackageCategory.Action,
        PackageCategory.Kinder,
        PackageCategory.HappyKids,
        PackageCategory.HappyKidsPlus,
        PackageCategory.Kinder,
    ];
    const categoriesWithEvents = [
        PackageCategory.EventS,
        PackageCategory.EventM,
        PackageCategory.EventL,
        PackageCategory.PolterabendNonPlusUltra,
        PackageCategory.PolterabendMegaFun,
        PackageCategory.EventMegaFun,
        PackageCategory.EventNonPlusUltra,
        PackageCategory.NonPlusUltra,
        PackageCategory.MegaFun,
        PackageCategory.GigaFun,
        PackageCategory.HappyParty,
        PackageCategory.HappyPartyPlus,
        PackageCategory.HappyPartyVIP,
    ];
    const isFamilyCategory = filter.category ? categoriesWithFamily.includes(filter.category) : false;
    const isEventsCategory = filter.category ? categoriesWithEvents.includes(filter.category) : false;

    if (isFamilyCategory) {
        return <BookingPackagesFamilyView />;
    }

    if (isEventsCategory) {
        return <BookingPackagesEventsView />;
    }

    return <BookingPackagesBasicCredits />;
};

export default withRouter(BookingPackagesNew);
